import { UserRoundPlusIcon } from '@air/design-icons';
import { Button } from '@air/primitive-button';
import { Tooltip } from '@air/primitive-tooltip';

import { type CantLeaveLibraryReason } from '~/components/LibraryBeta/hooks/useCanLeaveLibrary';

export const cantLeaveLibraryReasons: {
  [key in CantLeaveLibraryReason]: string;
} = {
  'sole-owner': 'You cannot leave this library as you are the only Library Owner.',
};

export type LibraryAdvancedSettingsLeaveLibraryProps = {
  onLeaveLibrary: () => void;
  cantLeaveLibraryReason: CantLeaveLibraryReason | undefined;
};

export const LibraryAdvancedSettingsLeaveLibrary = ({
  onLeaveLibrary,
  cantLeaveLibraryReason,
}: LibraryAdvancedSettingsLeaveLibraryProps) => {
  const button = (
    <Button
      disabled={!!cantLeaveLibraryReason}
      appearance="outline"
      color="gray"
      onClick={onLeaveLibrary}
      prefix={<UserRoundPlusIcon size="sm" />}
      data-testid="LIBRARY_SETTINGS_MODAL_LEAVE_BUTTON"
    >
      Leave library
    </Button>
  );

  return (
    <div>
      <h3 className="mb-2 font-bold ads:text-primary text-10 text-gray-12 uppercase tracking-wide">Leave library</h3>
      <p className="mb-4 ads:text-metadata text-12 text-gray-10">
        Remove library from sidebar and access to its contents
      </p>
      {cantLeaveLibraryReason ? (
        <Tooltip label={cantLeaveLibraryReasons[cantLeaveLibraryReason]}>{button}</Tooltip>
      ) : (
        button
      )}
    </div>
  );
};
